import React from "react";
import PropTypes from "prop-types";
import {
    FieldSet,
    FormGroupInput,
    //FormGroupSelect,
    FileUpload,
} from "components/formElements";
//import { getOptions } from "util/library";
import Select from "react-select";
import { getReactSelectOptions, CustomPlaceholder } from "util/library";



const LocationAndResume = ({
    handleChange,
    currentLocation,
    preferredJoiningCenter,
    candidateLocations,
    preferredLocations,
    handleFileChange,
    submitErrorMessage,
}) => (
    <FieldSet legendText="Location & Resume">
        {/*<FormGroupSelect*/}
        {/*  id="currentLocation"*/}
        {/*  name="currentLocation"*/}
        {/*  label="Current Location"*/}
        {/*  value={currentLocation}*/}
        {/*  onChange={handleChange}*/}
        {/*  required*/}
        {/*  options={getOptions(candidateLocations, "Select Current Location*")}*/}
        {/*/>*/}
        {/*<FormGroupSelect*/}
        {/*  id="preferredJoiningCenter"*/}
        {/*  name="preferredJoiningCenter"*/}
        {/*  label="Preferred Joining Center"*/}
        {/*  value={preferredJoiningCenter}*/}
        {/*  onChange={handleChange}*/}
        {/*  required*/}
        {/*  options={getOptions(preferredLocations, "Select Preferred Location*")}*/}
        {/*/>*/}
        {/*<Select*/}
        {/*    id="currentLocation"*/}
        {/*    name="currentLocation"*/}
        {/*    options={getReactSelectOptions(candidateLocations)}*/}
        {/*    value={getReactSelectOptions(candidateLocations).find(*/}
        {/*        (opt) => opt.value === currentLocation*/}
        {/*    )}*/}
        {/*    onChange={(selected) => handleChange({ target: { name: "currentLocation", value: selected.value } })}*/}
        {/*    placeholder={<CustomPlaceholder text="Select Current Location" />}*/}
        {/*    isRequired*/}
        {/*/>*/}

        {/*<Select*/}
        {/*    id="preferredJoiningCenter"*/}
        {/*    name="preferredJoiningCenter"*/}
        {/*    options={getReactSelectOptions(preferredLocations)}*/}
        {/*    value={getReactSelectOptions(preferredLocations).find(*/}
        {/*        (opt) => opt.value === preferredJoiningCenter*/}
        {/*    )}*/}
        {/*    onChange={(selected) => handleChange({ target: { name: "preferredJoiningCenter", value: selected.value } })}*/}
        {/*    placeholder={<CustomPlaceholder text="Select Preferred Location" />}*/}
        {/*    isRequired*/}
        {/*/>*/}
            <div style={{ width: "50%" }}>
                <Select
                    id="currentLocation"
                    name="currentLocation"
                    options={getReactSelectOptions(candidateLocations)}
                    value={getReactSelectOptions(candidateLocations).find(
                        (opt) => opt.value === currentLocation
                    )}
                onChange={(selected) =>
                    handleChange({ target: { name: "currentLocation", value: selected ? selected.value : "" } })
                }

                    placeholder={<CustomPlaceholder text="Select Current Location" />}
                styles={{
                    container: (base) => ({
                        ...base,
                        width: "95%",
                        marginLeft: "8px",
                    }),
                    control: (base) => ({
                        ...base,
                        height: "40px", 
                        minHeight: "40px",
                        border: "1px solid grey",
                        borderRadius: "2px"
                    }),
                }}
                isClearable={true}

                />
            </div>

            <div style={{ width: "50%"}}>
                <Select
                    id="preferredJoiningCenter"
                    name="preferredJoiningCenter"
                    options={getReactSelectOptions(preferredLocations)}
                    value={getReactSelectOptions(preferredLocations).find(
                        (opt) => opt.value === preferredJoiningCenter
                    )}
                onChange={(selected) =>
                    handleChange({ target: { name: "preferredJoiningCenter", value: selected ? selected.value : "" } })
                }
                    placeholder={<CustomPlaceholder text="Select Preferred Location" />}
                styles={{
                    container: (base) => ({
                        ...base,
                        width: "95%",
                        marginLeft: "8px",
                    }),
                    control: (base) => ({
                        ...base,
                        height: "40px",
                        minHeight: "40px",
                        border: "1px solid grey",
                        borderRadius: "2px"
                    }),
                }}
                isClearable={true}

                />
            </div>


        <FileUpload
            id="resume"
            name="resume"
            required
            handleFileChange={handleFileChange}
            submitErrorMessage={submitErrorMessage}
        />
        <FormGroupInput style={{ display: "none" }} />
    </FieldSet>
);

LocationAndResume.propTypes = {
    handleChange: PropTypes.func.isRequired,
    handleFileChange: PropTypes.func.isRequired,
    currentLocation: PropTypes.string.isRequired,
    preferredJoiningCenter: PropTypes.string.isRequired,
    candidateLocations: PropTypes.array.isRequired,
    preferredLocations: PropTypes.array.isRequired,
};

export { LocationAndResume };
